<template>
  <div class="image pr-32.5 flex">
    <div class="signature w-66 justify-end mt-auto">
      <p v-for="item in mark" :key="item" class="w-55 font-medium fz-16 mr-10" style="color: #6e758d">
        {{ item }}
      </p>
    </div>
    <img
        class="w-217.5 h-150"
        :src="require('@/assets/images/blog/' + source )"
        alt=""
    />
  </div>
</template>

<script>
export default {
  name: "imageWithMark",
  props:['source', 'mark']
}
</script>

<style scoped>

</style>